<a routerLink="/servico">
    <div class="product-two-item" (click)="_onClick()">
        <div class="capa" [ngStyle]="{'background-image': 'url('+data.foto+')'}"></div>
        <div class="bg"></div>
        <div class="content">
            <h4>{{data.nome}}</h4>
            <h5>{{data.categoria_titulo}}</h5>
        </div>    
    </div> 
</a>   